var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ opacity: _vm.loaded ? 1 : 0 })},[_c('canvas',{ref:"allStones",attrs:{"id":"allStones"}})])}
var staticRenderFns = []

export { render, staticRenderFns }